<template>
    <div>
        <div class="text-center text-144394 text-24 pb-4" v-html="title"></div>
        <div v-html="content"></div>
    </div>
</template>
<script>
// mixin
import ErrorApiMixin from '@/mixin/ErrorApiMixin.js';
// core
import BzbsPDPA from '@/core/PDPA/service/BzbsPDPA.js';
export default {
    name: 'PdpaContent',
    mixins: [ErrorApiMixin],
    props: {
        // version
        title: {type: String},
        version: { type: Number },
        // props
        type: { type: String, default: 'terms' }, // terms, privacy
        localeCode: { type: Number, default: 1054 },
        modalController: { type: Object }
    },
    data: function () {
        return {
            content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras quis sodales tellus, in hendrerit dui. Sed ac erat nec nisi imperdiet dictum. Pellentesque sed dui purus. Suspendisse a odio enim. Phasellus eros risus, eleifend quis dignissim vitae, finibus vitae odio. Nulla eu sapien sit amet velit rutrum consectetur. Phasellus maximus commodo neque, eget pellentesque erat consequat sit amet. Fusce sit amet tortor orci. Integer sit amet justo eu turpis faucibus cursus.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras quis sodales tellus, in hendrerit dui. Sed ac erat nec nisi imperdiet dictum. Pellentesque sed dui purus. Suspendisse a odio enim. Phasellus eros Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras quis sodales tellus, in hendrerit dui. Sed ac erat nec nisi imperdiet dictum. Pellentesque sed dui purus. Suspendisse a odio enim. Phasellus eros risus, eleifend quis dignissim vitae, finibus vitae odio. Nulla eu sapien sit amet velit rutrum consectetur. Phasellus maximus commodo neque, eget pellentesque erat consequat sit amet. Fusce sit amet tortor orci. Integer sit amet justo eu turpis faucibus cursus.Lorem ipsum dolor sit amet, Phasellus maximus commodo neque, eget eleifend',
            contentVersion: ''
        };
    },
    created: function () {
        //this.initPdpa();
    },
    methods: {
        initPdpa: async function () {
            await this.getVersion();
            if (!this.contentVersion) return;

            await this.getContent();
            if (!this.content) return;
        },
        getVersion: function () {
            return new Promise((resolve) => {
                BzbsPDPA.apiGetPDPAVersion()
                    .subscribe({
                        next: (res) => {
                            const result = this.type == 'terms'
                                ? res.terms.current_version
                                : res.privacy.current_version;

                            this.contentVersion = result;
                            this.$emit('update:version', this.contentVersion);
                            resolve(true);
                        },
                        error: (err) => {
                            this.sendError(err);
                            resolve(null);
                        }
                    });
            });
        },
        getContent: function () {
            return new Promise((resolve) => {
                BzbsPDPA.apiGetPDPAContent(this.type, this.contentVersion, this.localeCode)
                    .subscribe({
                        next: (res) => {
                            this.content = res;

                            resolve(res);
                        },
                        error: (err) => {
                            this.sendError(err);
                            resolve(null);
                        }
                    });
            });
        },
        sendError: function (error) {
            this.$emit('onError', error);
        }
    }
}
</script>
